export enum EttIntubation {
  /// Интубация ЭТТ
  Value10 = 10, // Represents 1.0
  Value15 = 15, // Represents 1.5
  Value20 = 20, // Represents 2.0
  Value25 = 25, // Represents 2.5
  Value30 = 30, // Represents 3.0
  Value35 = 35, // Represents 3.5
  Value40 = 40, // Represents 4.0
  Value45 = 45, // Represents 4.5
  Value50 = 50, // Represents 5.0
  Value55 = 55, // Represents 5.5
  Value60 = 60, // Represents 6.0
  Value65 = 65, // Represents 6.5
  Value70 = 70, // Represents 7.0
  Value75 = 75, // Represents 7.5
  Value80 = 80, // Represents 8.0
  Value85 = 85, // Represents 8.5
  Value90 = 90, // Represents 9.0
  Value95 = 95, // Represents 9.5
  Value100 = 100, // Represents 10.0
}
